import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Card = styled.div`
  align-self: center;
  background-color: ${props => props.theme.colors.background.primary};
  box-shadow: ${props => props.theme.elevation.elevation2};
`
